import { render, staticRenderFns } from "./SaleRequestsCreditsAlert.vue?vue&type=template&id=603efc16&"
import script from "./SaleRequestsCreditsAlert.vue?vue&type=script&lang=ts&"
export * from "./SaleRequestsCreditsAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports